// import RadioGroup from '../form/grouped/radio/radio-group';
import { IDTypeEnum } from '../../models/enum/id-type.enum';
import { MaritalStatusEnum } from '../../models/enum/marital-status.enum';
// import { IdTypes } from '../../utils/shared-radio';
import { idTypesInterface } from '../../utils/shared-dropdown';
import { P2TextInput } from 'react-bootstrap-common-script';
import { Dropdown } from '../dropdown';

function IdForm({...props}:any) {
  let placeholder = "Key in your ID here";
  if(props.item?.id_type === IDTypeEnum.uinfin){
    placeholder = "e.g. S999999; T9999999X";
  }
  else if(props.item?.id_type === IDTypeEnum.foreign_id){
    placeholder = "e.g. F9999999X; G9999999X; M9999999X";
  }

  return <>
      <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={props.disableFields} required selectedDropdown={props.item?.id_type} placeholder="Please select identification type" label={`Select identification type`} items={idTypesInterface} setSelectedDropdown={(value: any) => {
              props.handleValueChange(value,"id_type")
          }}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <P2TextInput forceError={props?.forceError} disabled={props.disableFields} isError={!props.itemHoldingErrors?.myinfo?.uinfin?.isValid} errorMsg={props.itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='name' label='Identification Number' maxLength={256} placeholder={placeholder} type='text' onChange={(value:any)=>{
          props.handleValueChange(value?.toUpperCase(),"uinfin")
        }} />
      </div>
  </>
}

export default IdForm